import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

const Quote = {
  Content: lazy(
    () => import('components/direct-sales/quote/components/Tariffs')
  ),
  LeftSidebar: lazy(
    () => import('components/direct-sales/quote/components/QuoteSidebarLeft')
  ),
  Header: lazy(
    () => import('components/direct-sales/quote/components/QuoteHeaderRevamp')
  ),
  Skyline: lazy(
    () => import('components/direct-sales/quote/components/PriceCapBanner')
  ),
  Footer: lazy(
    () => import('components/direct-sales/quote/components/QuoteFooter')
  )
};

export default Quote;
